import { createFileRoute } from '@tanstack/react-router';
import { ImportPagFor } from '@/features/pagfor/page/importar';

export const Route = createFileRoute('/a/pagfor/importar')({
    component: ImportPagFor,
});
